export default __webpack_public_path__ + "static/media/CardHolderIcon.477985c1.svg";